(ns manage.product-selector-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem]]
            ["src/svg/inform/plus.svg$default" :as Plus]
            [cljs-bean.core :as bean]
            [clojure.string :as str]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.product-selector :as product-selector.q]
            [common.uix.hooks :refer [use-copy-with-toaster]]
            [common.util :refer [format-iso-string]]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal confirm-delete :product-selector/confirm-delete
  [{:keys [on-confirm]}]
  [deletion-confirmation
   {:on-submit on-confirm
    :entity-name "Product Selector"
    :confirmation-message "Are you sure you want to delete this product selector? This action cannot be undone."}])

(defui format-name
  [{:keys [name valid]}]
  ($ Stack {:direction "row" :alignItems "center" :spacing 1}
     ($ :span name)
     (when-not valid
       ($ Chip {:label "Invalid"}))))

(defhook use-columns []
  (let [{:keys [advertiser-id] :as url-context} (use-subscribe [:url-context])
        {duplicate-product-selector :mutate} (use-mutation (product-selector.q/duplicate-product-selector-mutation
                                                            {:advertiser-id advertiser-id}))
        {delete-product-selector :mutate} (use-mutation (product-selector.q/delete-product-selector-mutation
                                                         {:advertiser-id advertiser-id}))
        copy-to-clipboard (use-copy-with-toaster {:success-message "Copied product selector ID"})]
    #js [#js {:field "name"
              :headerName "Name"
              :valueGetter (fn [_value row] (:name row))
              :renderCell (fn [^js params]
                            ($ format-name (.-row params)))
              :flex 2}
         #js {:field "id"
              :headerName "Id"
              :valueGetter (fn [_value row] (:id row))
              :flex 1}
         #js {:field "updated-at"
              :headerName "Last modified"
              :valueGetter (fn [_value row] (format-iso-string (:updated-at row)))
              :flex 1}
         #js {:field "actions"
              :headerName "Actions"
              :type "actions"
              :getActions (fn [^js params]
                            (let [row (.-row params)]
                              #js [($ GridActionsCellItem
                                      {:label "Open in new tab"
                                       :onClick (fn []
                                                  (let [url (r.easy/href :advertiser/product-selector url-context {:product-selector-id (:id row)})]
                                                    (.open js/window url "_blank")))
                                       :showInMenu true})
                                   ($ GridActionsCellItem
                                      {:label "Copy ID"
                                       :onClick (fn []
                                                  (copy-to-clipboard (:id row)))
                                       :showInMenu true})
                                   ($ GridActionsCellItem
                                      {:label "Duplicate"
                                       :onClick (fn []
                                                  (duplicate-product-selector {:id (:id row)
                                                                               :name (str (:name row) " - Copy")}))
                                       :showInMenu true})
                                   ($ GridActionsCellItem
                                      {:label "Delete"
                                       :onClick (fn []
                                                  (rf/dispatch [:modal/open {:id :product-selector/confirm-delete
                                                                             :props {:on-confirm #(delete-product-selector
                                                                                                   {:id (:id row)})}}]))
                                       :showInMenu true})]))
              :flex 0}]))

(def get-row-count (comp :total :meta))

(defn get-row-id [row] (:id row))

(def Toolbar
  (uix/as-react
   (fn [{:keys [quick-filter-props url-context]}]
     ($ dg/grid-toolbar {:quick-filter-props quick-filter-props}
        (when (use-subscribe [:resource.user/allowed? "products.edit"])
          ($ Button
             {:data-testid "OCP | Create Product Selector"
              :href (r.easy/href :advertiser/product-selector url-context)
              :startIcon ($ Plus)
              :variant "contained"}
             "New product selector"))))))

(defui product-selector-table []
  (let [{:keys [advertiser-id] :as url-context} (use-subscribe [:url-context])
        columns (use-columns)
        on-row-click (uix/use-callback
                      (fn [^js params]
                        (rf/dispatch [:ocp/open {:id :product-selector/crud
                                                 :props {:product-selector-id (:id (.-row params))}}]))
                      [])
        table-query-fn (uix/use-callback
                        (fn [{:keys [^js filter-model ^js sort-model ^js pagination-model]}]
                          (product-selector.q/product-selectors-query
                           {:advertiser-id advertiser-id
                            :term (str/join " " (.-quickFilterValues filter-model))
                            :sort (bean/->clj (first sort-model))
                            :page-size (.-pageSize pagination-model)}))
                        [advertiser-id])
        server-table-props (dg/use-server-table-props
                            {:table-query-fn table-query-fn
                             :disable-default-transform true
                             :transform-response-fn :items
                             :get-row-count-fn get-row-count
                             :initial-pagination-model #js {:page 0 :pageSize 10}
                             :initial-sort-model #js [#js {:field "updated-at" :sort "desc"}]})]
    ($ DataGridPremium
       (merge
        server-table-props
        {:columns columns
         :getRowId get-row-id
         :onRowClick on-row-click
         :disableRowSelectionOnClick true
         :slots #js {:toolbar Toolbar}
         :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                         :toolbar #js {:quick-filter-props {:inputProps #js {:data-testid "searchInput"}}
                                       :url-context url-context}}
         :sx #js {:maxHeight "70rem"}}))))
